import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { createBankAccount } from '../requests'
import { BankAccount, createBankAccountRequestSchema } from '../schema'
import z from 'zod'

type CreateBankAccountVariables = z.input<typeof createBankAccountRequestSchema>

function useCreateBankAccount(
  options?: Omit<
    UseMutationOptions<BankAccount, Error, CreateBankAccountVariables>,
    'mutationFn'
  >
) {
  return useMutation({
    mutationFn: createBankAccount,
    ...options,
  })
}

export default useCreateBankAccount
